<script>
  import { layoutMethods,careersMethods } from "@/state/helpers";
  import { required } from "vuelidate/lib/validators";
  import CKEditor from "@ckeditor/ckeditor5-vue";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'
  import Choices from "choices.js";
  
  /**
   * Job Opening Form List component
   */
  export default {
    page: {
      title: "Career form"
    },
    components: {
      ckeditor: CKEditor.component,
    },
    computed: {
    },
    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {removePlugins: [ 'Blockquote', 'Image', 'ImageToolbar', 'List' ]},
        title: "Career Form",
        career_id: 0,
        submitted: false,
        form:{
          status          : true,
          job_title       : null,
          job_status      : null,
          job_description : null,
          employment_type : null,
          location        : null,
          work_setup      : null,
          work_shift      : null,
          department      :null,
          hiring_manager_email:null,
          role_responsibilities:null,
          job_requirements: null,        
        },
        formExitChecker:{
          status          : true,
          job_title       : null,
          job_status      : null,
          job_description : null,
          employment_type : null,
          location        : null,
          work_setup      : null,
          work_shift      : null,
          department      :null,
          hiring_manager_email:null,
          role_responsibilities:null,
          job_requirements: null,        
        },
        statusOption:[
          {"value": null,"text":"Select Job Title Status", disabled:true},
          {"value":"o","text":"Open"},
          {"value":"c","text":"Close"}
        ],
        employmentTypeOption:[
          {"value": null,"text":"Select Employment Type", disabled:true},
          {"value":"f","text":"Full Time"},
          {"value":"p","text":"Part Time"},
          {"value":"i","text":"Intern"},
          {"value":"c","text":"Contractual/Consultant"}
        ],
        locationOption:[
          {"value": null,"text":"Select Location", disabled:true},
          {"value":"Catbalogan City, Samar","text":"Catbalogan City, Samar"},
          {"value":"Metro Manila","text":"Metro Manila"},
          {"value":"Remote Work Set-up","text":"Remote Work Set-up"},
        ],
        workSetupOption:[
          {"value": null,"text":"Select Work Setup", disabled:true},
          {"value":"of","text":"Office"},
          {"value":"os","text":"Off-Site"}
        ],
        workShiftOption:[
          {"value": null,"text":"Select Work Shift", disabled:true},
          {"value":"m","text":"Morning"},
          {"value":"n","text":"Night"},
          {"value":"f","text":"Flexible Work Arrangement"}
        ],
        departmentOption:[
          {"value": null,"text":"Select Department Name", disabled:true},
          {"value":"Human Resources","text":"Human Resources - People Culture"},
          {"value":"Finance","text":"Finance - Accounting and Finance"},
          {"value":"Business Development","text":"Business Development - Strategy and Implementation"},
          {"value":"Operations","text":"Operations - Customer Success and Branding"},
          {"value":"Product","text":"Product - Digital and Information Technology"},
          {"value":"Others","text":"Office of the CEO/Interns/Management Trainees - Others"}
        ],
        jobOpeningModule: {
          access: {
            create: true,
            update: true
          }
        }
      };
    },
    validations: {
      form: {
        status              : {required},
        job_title           : {required},
        job_status          : {required},
        job_description     : {required},
        employment_type     : {required},
        location            : {required},
        work_setup          : {required},
        work_shift          : {required},
        department          : {required},
        hiring_manager_email: {required},
        role_responsibilities:{required},
        job_requirements    : {required},
      },
    },
    methods: {
      ...layoutMethods,
      ...careersMethods,
      async handleSubmit(){
        this.hiringManagerEmails();
        this.submitted = true;
        this.$v.$touch();
        if (!this.$v.form.$invalid){
            // console.log(":: FORM ::", JSON.stringify(this.form));
            await this.actionCareers({
                action: this.career_id > 0 ? "update":"create",
                body: this.career_id > 0 ? {...this.form,"career_id":this.career_id}:this.form
            })
            .then((res) => {
              console.log(res);
              Swal.fire(
                // (this.career_id > 0 ?"Updated":"Created")+" Successful!",
                // `${this.form.job_title} has been ${(this.career_id > 0 ?"updated":"created")}.`,
                "Posting Successful!",
                `${this.form.job_title} is posted`,
                "success"
              );
              this.formExitChecker = this.form
              if(this.career_id > 0){
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: 'View Job Opening', params: { id : this.career_id }
                  }
                );
              }else{
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: "Job Opening"
                  }
                );
              }
            }).catch((e)=>{
              console.log("error while creating a job",e);
            });
        }
      },
      leaveform(next){
          if(JSON.stringify(this.form) == JSON.stringify(this.formExitChecker)){
              next();
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
      async getJobDetails(){
        await this.actionCareers({
            action: "job-details",
            body: {"career_id":this.career_id,"type":"form"}
        })
        .then((res) => {
          console.log(res);
          this.form.status                = res["message"]["status"] 
          this.form.job_title             = res["message"]["job_title"] 
          this.form.job_status            = res["message"]["job_status"] 
          this.form.job_description       = res["message"]["job_description"] 
          this.form.employment_type       = res["message"]["type"] 
          this.form.location              = res["message"]["location"] 
          this.form.work_setup            = res["message"]["work_setup"] 
          this.form.work_shift            = res["message"]["work_shift"] 
          this.form.department            = res["message"]["department"]
          this.form.hiring_manager_email  = res["message"]["hiring_manager_email"]//.split(",")
          this.form.role_responsibilities = res["message"]["role_resp"]
          this.form.job_requirements      = res["message"]["job_requirements"] 
          this.formExitChecker            = {...this.form}
        }).catch((e)=>{
          console.log("error while getting job details",e);
        });
      },
      cancelRouting(){
        if(this.career_id > 0){
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: 'View Job Opening', params: { id : this.career_id }
            }
          );
        }else{
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Job Opening"
            }
          );
        }
      },
      hiringManagerEmails(){
        this.form.hiring_manager_email = document.getElementById("hiring-manager-emails").value;
        // console.log(this.form.hiring_manager_email);
      }
    },
    async mounted(){
      this.changeTitle({title: 'Career Form'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Careers', to: { name: 'Job Opening'} },
          { text: 'Job Opening', to: { name: 'Job Opening'} },
          { text: 'Form', to: { name: 'Add Job Opening'} }
        ]
      });
      this.career_id = this.$route.params.id;
      if(this.career_id > 0){
        await this.getJobDetails();
      }
      //this will format the emails
      new Choices(document.getElementById("hiring-manager-emails"), {
        delimiter: ",",
        editItems: true,
        maxItemCount: 10,
        removeItemButton: true,
        placeholderValue: "Enter Manager Email Address",
        duplicateItemsAllowed: false,
      });
      //assign values
      var self = this;
      document.getElementById("hiring-manager-emails").addEventListener(
        'change',
        function() {
          // each time an item is added & removed
          // if(self.validateEmail(event.detail.value)){
            self.hiringManagerEmails();
          // }
        },
        false,
      );

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Careers', 'Job Opening')
        .then((access) => this.jobOpeningModule.access = access);
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.form) != JSON.stringify(this.formExitChecker)){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">

                  <form class="px-4" @submit.prevent="handleSubmit()">

                    <div class="row">
                      <label v-if="career_id == 0 && !jobOpeningModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a Job Opening.</label>
                      <label v-else-if="career_id > 0 && !jobOpeningModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a Job Opening.</label>    
                      <div class="col-md-12 mb-3"><!--start active status-->
                        <div class="form-check form-switch">
                          <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                          <input
                            class="form-check-input"
                            v-model="form.status"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </div><!--end active status-->
                      <div class="mb-3 col-md-8"><!--job title-->
                        <label class="form-label small fw-bold">Job Title<span style="color: red">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.job_title"
                          placeholder="Enter Job Title"
                          :class="{
                              'is-invalid': submitted && $v.form.job_title.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.job_title.$error"
                          class="text-danger">
                          <span v-if="!$v.form.job_title.required">This value is required.</span>
                        </div>
                      </div><!--job title-->
                      <div class="col-md-4 mb-3"><!--Job status-->
                        <label class="form-label small fw-bold">Job Status<span style="color: red">*</span></label>
                        <b-form-select
                          class="form-control" 
                          placeholder="Select Status here"
                          v-model="form.job_status" 
                          :options="statusOption" 
                          :class="{
                              'is-invalid': submitted && $v.form.job_status.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.job_status.$error"
                          class="text-danger">
                          <span v-if="!$v.form.job_status.required">This value is required.</span>
                        </div>
                      </div><!--job status-->
                      <div class="col-md-12 mb-3"><!--Job Description-->
                        <template>
                          <div>
                            <label class="form-label">Job Description<span style="color: red">*</span></label>
                            <b-form-textarea
                              id="textarea"
                              v-model="form.job_description"
                              placeholder="Type job description here..."
                              rows="3"
                              max-rows="6"
                              :class="{
                                  'is-invalid': submitted && $v.form.job_description.$error,
                              }"
                            ></b-form-textarea>
                            <div v-if="submitted && $v.form.job_description.$error"
                              class="text-danger">
                              <span v-if="!$v.form.job_description.required">This value is required.</span>
                            </div>
                          </div>
                        </template>
                      </div><!--Event Note-->
                      <div class="col-md-6 mb-3"><!--employment type-->
                        <label class="form-label small fw-bold">Employment Type<span style="color: red">*</span></label>
                        <b-form-select
                          class="form-control" 
                          placeholder="Select employment type here"
                          v-model="form.employment_type" 
                          :options="employmentTypeOption" 
                          :class="{
                              'is-invalid': submitted && $v.form.employment_type.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.employment_type.$error"
                          class="text-danger">
                          <span v-if="!$v.form.employment_type.required">This value is required.</span>
                        </div>
                      </div><!--employment type-->
                      <div class="col-md-6 mb-3"><!--location-->
                        <label class="form-label small fw-bold">Location<span style="color: red">*</span></label>
                        <b-form-select
                          class="form-control" 
                          placeholder="Select location here"
                          v-model="form.location" 
                          :options="locationOption" 
                          :class="{
                              'is-invalid': submitted && $v.form.location.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.location.$error"
                          class="text-danger">
                          <span v-if="!$v.form.location.required">This value is required.</span>
                        </div>
                      </div><!--lcoation-->
                      <div class="col-md-6 mb-3"><!--work set-up -->
                        <label class="form-label small fw-bold">Work Set-up (Majority of the Time)<span style="color: red">*</span></label>
                        <b-form-select
                          class="form-control" 
                          placeholder="Select work set-up here"
                          v-model="form.work_setup" 
                          :options="workSetupOption" 
                          :class="{
                              'is-invalid': submitted && $v.form.work_setup.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.work_setup.$error"
                          class="text-danger">
                          <span v-if="!$v.form.work_setup.required">This value is required.</span>
                        </div>
                      </div><!--work setup-->
                      <div class="col-md-6 mb-3"><!--work shift -->
                        <label class="form-label small fw-bold">Work Shift<span style="color: red">*</span></label>
                        <b-form-select
                          class="form-control" 
                          placeholder="Select work shift here"
                          v-model="form.work_shift" 
                          :options="workShiftOption" 
                          :class="{
                              'is-invalid': submitted && $v.form.work_shift.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.work_shift.$error"
                          class="text-danger">
                          <span v-if="!$v.form.work_shift.required">This value is required.</span>
                        </div>
                      </div><!--work shift-->
                      <div class="col-md-4 mb-3"><!--Department -->
                        <label class="form-label small fw-bold">Department Name<span style="color: red">*</span></label>
                        <b-form-select
                          class="form-control" 
                          placeholder="Select work shift here"
                          v-model="form.department" 
                          :options="departmentOption" 
                          :class="{
                              'is-invalid': submitted && $v.form.department.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.department.$error"
                          class="text-danger">
                          <span v-if="!$v.form.department.required">This value is required.</span>
                        </div>
                      </div><!--department-->
                      <div class="col-md-8 mb-3"><!--hiring manager email address-->
                        <label class="form-label small fw-bold">Hiring Manager: Email Address<span style="color: red">*</span></label>
                        <!--b-form-tags-->
                        <!-- <b-form-tags
                          input-id="tags-pills"
                          v-model="form.hiring_manager_email"
                          tag-variant="primary"
                          tag-pills
                          separator=" "
                          placeholder="Enter new tags separated by space"
                        ></b-form-tags> -->
                        <!-- <p class="mt-2">Value: {{ form.hiring_manager_email }}</p> -->
                        <!--Choices config-->
                        <input
                          class="form-control"
                          placeholder="Enter Hiring Manager Email Address"
                          id="hiring-manager-emails"
                          type="text"
                          v-model="form.hiring_manager_email"
                          :class="{
                              'is-invalid': submitted && $v.form.hiring_manager_email.$error,
                          }"
                        />
                        <!--old input-->
                        <input v-if="false"
                          type="text"
                          class="form-control"
                          v-model="form.hiring_manager_email"
                          placeholder="Enter Hiring Manager Email Address"
                          :class="{
                              'is-invalid': submitted && $v.form.hiring_manager_email.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.hiring_manager_email.$error"
                          class="text-danger">
                          <span v-if="!$v.form.hiring_manager_email.required">This value is required.</span>
                        </div>
                      </div><!--hiring manager email address-->
                      <div class="col-md-12 mb-3"><!--role responsibilities -->
                        <label class="form-label small fw-bold">Role Responsibilities<span style="color: red">*</span></label>
                        <ckeditor 
                          v-model="form.role_responsibilities" 
                          :editor="editor"
                          :class="{
                              'is-invalid': submitted && $v.form.role_responsibilities.$error,
                          }"
                        ></ckeditor>
                           <!-- :config="editorConfig" -->
                        <!-- <quill-editor v-model="form.role_responsibilities" output="html" style="height: 300px;" ></quill-editor> -->
                        <div v-if="submitted && $v.form.role_responsibilities.$error"
                          class="text-danger">
                          <span v-if="!$v.form.role_responsibilities.required">This value is required.</span>
                        </div>
                      </div><!--role responsibilities-->
                      <div class="col-md-12 mb-3"><!--job requirement -->
                        <label class="form-label small fw-bold">Job Requirements<span style="color: red">*</span></label>
                        <ckeditor 
                          v-model="form.job_requirements" 
                          :editor="editor"
                          :class="{
                              'is-invalid': submitted && $v.form.job_requirements.$error,
                          }"
                        ></ckeditor>
                        <!-- <quill-editor v-model="form.job_requirements" output="html" style="height: 300px;" ></quill-editor> -->
                        <div v-if="submitted && $v.form.job_requirements.$error"
                          class="text-danger">
                          <span v-if="!$v.form.job_requirements.required">This value is required.</span>
                        </div>
                      </div><!--Job Requirements-->

                    </div><!--end of row-->

                    <div class="row mt-3 mb-2 px-3"><!--start of row button group-->
                      <div class="col-md-12 mt-3 ta-right p-0">
                        <b-button :disabled="career_id >= 0 ? !jobOpeningModule.access.create : !jobOpeningModule.access.update" variant="primary" class="w-sm me-2" type="submit">Post</b-button>
                        <b-button variant="light" class="w-sm ml-2" type="button" @click="cancelRouting" >Cancel</b-button>
                      </div>
                    </div><!--end of row button group-->

                  </form>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>